/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 *
 * @export
 * @interface ServiceLink
 */
export interface ServiceLink {
    /**
     *
     * @type {string}
     * @memberof ServiceLink
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ServiceLink
     */
    content?: string;
    /**
     *
     * @type {string}
     * @memberof ServiceLink
     */
    link: string;
}

export function ServiceLinkFromJSON(json: any): ServiceLink {
    return ServiceLinkFromJSONTyped(json, false);
}

export function ServiceLinkFromJSONTyped(json: any, _: boolean): ServiceLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': json['title'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'link': json['link'],
    };
}

export function ServiceLinkToJSON(value?: ServiceLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'content': value.content,
        'link': value.link,
    };
}
